<div class="service-unavailable-container">
    <div class="service-unavailable-content">
        <div class="smash-logo">
            <i class="icon-smash_icologo_chip"></i>
        </div>
        <div class="service-unavailable-message">
            <h1 *ngIf="browserLanguage === 'fr'">
                Oups!
            </h1>
            <h1 *ngIf="browserLanguage === 'en'">
                Oops!
            </h1>
            <h1 *ngIf="browserLanguage === 'de'">
                Upps!
            </h1>
            <h1 *ngIf="browserLanguage === 'es'">
                ¡Vaya!
            </h1>
            <h1 *ngIf="browserLanguage === 'it'">
                Oops!
            </h1>
            <h1 *ngIf="browserLanguage === 'pt'">
                Ups!
            </h1>
            <p *ngIf="browserLanguage === 'fr'">
                Il semblerait que le service soit temporairement indisponible, nous faisons tout notre possible pour le
                rétablir !
            </p>
            <p *ngIf="browserLanguage !== 'fr'">
                It seems that the service is temporarily unavailable, we are doing everything we can to
                to come back !
            </p>
            <a *ngIf="browserLanguage === 'fr'" href="/" class="btn red button-copy">Réessayer</a>
            <a *ngIf="browserLanguage !== 'fr'" href="/" class="btn red button-copy">Try again</a>
        </div>
    </div>
</div>